import { render, staticRenderFns } from "./WesErrorPanel.vue?vue&type=template&id=2eb4f964&scoped=true&"
import script from "./WesErrorPanel.vue?vue&type=script&lang=js&"
export * from "./WesErrorPanel.vue?vue&type=script&lang=js&"
import style0 from "./WesErrorPanel.vue?vue&type=style&index=0&id=2eb4f964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4f964",
  null
  
)

export default component.exports